/*
 * Product page: keep Bazaarvoice's empty placeholders out of the layout (2026-09-30, layout shift).
 *
 * The reviews widget draws inside an open shadow root. Its first paint contains two empty boxes (a 431px and a 108px
 * tall slot for review highlights) that the widget grows to 841px and then removes a few seconds later when the product
 * has nothing to put there. The reviews below them jump up by 300 to 900px while the visitor is reading them
 * (layout shift 0.4 to 0.5). This adds one small stylesheet to that shadow root that gives an EMPTY slot no height. The
 * moment the widget puts content into a slot it is no longer :empty and shows as before, so nothing is hidden that
 * would have been shown. A class name that stops matching only brings back today's behaviour.
 *
 * Theme code only, Bazaarvoice's own scripts are not touched.
 */
(function () {
  'use strict';
  var CSS = '.bv-rnr__sc-1qec6v5-4:empty,.bv-rnr__sc-104nfmk-0:has(.bv-rnr__sc-1qec6v5-4:empty){display:none!important}';

  function patch(root) {
    if (!root || root.__umbraStable) return;
    root.__umbraStable = true;
    try {
      var sheet = new CSSStyleSheet();
      sheet.replaceSync(CSS);
      root.adoptedStyleSheets = root.adoptedStyleSheets.concat([sheet]);
    } catch (e) {
      var st = document.createElement('style');
      st.textContent = CSS;
      root.appendChild(st);
    }
  }

  // Hook the moment Bazaarvoice attaches its shadow root, so the rule is in place before the first paint of the slots.
  var attach = Element.prototype.attachShadow;
  if (attach) {
    Element.prototype.attachShadow = function (init) {
      var root = attach.call(this, init);
      try { if (this.hasAttribute('data-bv-show')) patch(root); } catch (e) {}
      return root;
    };
  }

  // The rating line in the buy box keeps its final size (product-page.css) until Bazaarvoice has answered. html.umbra-bv-norating
  // releases it when the answer is "no stars" (a product without reviews) or there is no answer at all (script blocked).
  var root = document.documentElement;
  var rating = document.querySelector('[data-bv-show="rating_summary"]');
  if (rating) {
    var hasStars = function () { return !!rating.querySelector('svg, .bv_stars_component_container'); };
    var timer = null;
    var check = function () {
      clearTimeout(timer);
      if (hasStars()) {
        root.classList.remove('umbra-bv-norating');
      } else if (rating.hasAttribute('data-bv-ready')) {
        timer = setTimeout(function () { if (!hasStars()) root.classList.add('umbra-bv-norating'); }, 3000);
      }
    };
    if ('MutationObserver' in window) {
      new MutationObserver(check).observe(rating, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-bv-ready'] });
    }
    check();
    setTimeout(function () { if (!hasStars()) root.classList.add('umbra-bv-norating'); }, 45000);
  }

  // A root that already exists (this file ran late).
  var n = 0;
  (function scan() {
    var hosts = document.querySelectorAll('[data-bv-show]');
    for (var i = 0; i < hosts.length; i++) patch(hosts[i].shadowRoot);
    if (++n < 100) setTimeout(scan, 300);
  })();
})();
